import { action, makeObservable } from 'mobx';
import {ChangeEvent, ChangeEventHandler} from 'react';
import {Control} from './Control';

export class StringControl extends Control<string> {
  @action
  onChangeHandler: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> =
    (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      this.setValue(event.target.value);
    };

  @action
  clear = () => {
    this.setValue('');
  };

//   constructor(readonly name: string,
//     initialValue: string,
//     validators?: ValidatorFn<string> | ValidatorFn<string> [] | null,
//     valueChanges?: ValueChangeListener<string> | ValueChangeListener<string>[]) {
//     // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
//     super(name, initialValue);

//     makeObservable(this);
//   }
}
